import { Component } from '@angular/core';

@Component({
    selector: 'app-tnc',
    imports: [],
    templateUrl: './tnc.component.html',
    styleUrl: './tnc.component.scss'
})
export class TncComponent {

}
